
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/mini-sudoku/[date]",
      function () {
        return require("private-next-pages/games/mini-sudoku/[date]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/mini-sudoku/[date]"])
      });
    }
  